<app-section *ngIf="deviceService.isCameraSupported && sectionVisible"
             [formConfig]="formConfig"
             [formGroup]="formGroup"
             [sectionRef]="section"
             [title]="title">

    <ng-template #section>
        <div class="aztec-section">
            <div class="aztec-section__top-container">
                <div class="aztec-section__top-container--left-column">
                    <img class="aztec-section__top-container--left-column__image"
                         width="80"
                         height="91"
                         [src]="'./assets/images/aztec-document.webp'">
                </div>
                <div class="aztec-section__top-container--right-column"
                     [innerHTML]="'AZTEC_SECTION.contentText'| translate | safeHtml"></div>
            </div>
            <div class="aztec-section__bottom-container">
                <button class="aztec-section__bottom-container--btn btn btn--secondary" (click)="openAztecReader()">
                    {{"AZTEC_SECTION.buttonLabel" | translate}}
                </button>
            </div>
        </div>
    </ng-template>
</app-section>
